<template>
  <modal :value="value"
         max-width="500"
         content-class="sms-plan-add-form modal-device"
         :has-padding="false"
         @input="emitInput">

    <div class="sms-plan-add-form-body">
      <form @submit.prevent="addCredit">
        <div class="sms-plan-add-form-body-header">
          <button type="button"
                  @click="emitBack">
            <i class="mdi mdi-arrow-left pointer"></i>
          </button>
          <h1>{{ headerText }}</h1>
        </div>

        <div class="sms-plan-add-form-body-inputs">
          <v-text-field v-model="form.amount"
                        type="number"
                        name="Quantidade"
                        :label="$t('message.generics.message.amount')"
                        v-validate="'required'"
                        :error-messages="errors.collect($t('message.generics.message.amount'))"></v-text-field>

          <BoxWrapper class="mb-4"
                      :data-label="$t('message.creditManagement.message.expirationDate')"
                      data-icon="mdi-calendar-range">

            <DatePicker v-model="form.expirationDate" />

          </BoxWrapper>
        </div>

        <v-card-actions class="sms-plan-add-form-body-actions">
          <button class="btn btn-extra-round btn-primary">
            {{$t('message.generics.message.add')}}
          </button>
        </v-card-actions>
      </form>
    </div>
  </modal>
</template>

<script>
import BoxWrapper from "@components/BoxWrapper";
import DatePicker from "@components/DatePicker";
import Modal from "@/components/generic/Modal";
import moment from "moment";

export default {
  data() {
    return {
      page: 0,
      possiblePlans: [],
      form: {
        amount: undefined,
        expirationDate: undefined,
      },
    };
  },
  components: {
    DatePicker,
    BoxWrapper,
    Modal,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  created() {
    const date = moment().add(1, "month").format("YYYY-MM-DD");

    this.form.expirationDate = date;
  },
  computed: {
    headerText() {
      const typeText = {
        "EMAIL": "E-mail",
        "SMS": "SMS",
        "WHATSAPP": "WhatsApp"
      }[this.type];

      return `${this.$t("message.generics.message.add")} ${typeText}`;
    },
  },
  methods: {
    emitBack() {
      this.$emit("back");
    },
    emitInput(value) {
      this.$emit("input", value);
    },
    hideModal() {
      this.emitInput(false);
    },
    async addCredit() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        await this.$api.marketing.account.credit.add({
          accountId: this.item.id,
          amount: Number(this.form.amount),
          expirationDate: this.form.expirationDate,
          type: this.type,
        });

        this.$emit("added");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sms-plan-add-form {
  .sms-plan-add-form-body {
    padding: 10px 20px;

    .sms-plan-add-form-body-header {
      position: relative;

      h1 {
        text-align: center;
        font-size: 30px;
        font-weight: 600;
        margin-bottom: 40px;
      }

      button {
        position: absolute;
        font-size: 30px;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }

    .sms-plan-add-form-body-inputs {
      width: 60%;
      margin: 0 auto 30px;
    }

    .sms-plan-add-form-body-actions {
      display: flex;
      justify-content: center;

      .btn {
        font-weight: 600;
        width: 200px;
        font-size: 15px;
        box-shadow: 0px 3px 6px #00000024;
      }
    }
  }
}
</style>
